import { Form } from 'antd';
import { FormInstance } from 'antd/es/form';
import React, { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router';

import ConfirmSignUp from '../components/AuthComponents/ConfirmSignUp';
import ForgotPassword from '../components/AuthComponents/ForgotPassword';
import NewPassword from '../components/AuthComponents/NewPassword';
import SignIn from '../components/AuthComponents/SignIn';
import SignUp from '../components/AuthComponents/SignUp';
import { redirectToLogin } from '../components/utils';

export interface IAuthProps extends IProps {
  form: FormInstance;
}

interface IProps {
  onStateChange?: any;
  onAuthEvent?: any;
  authState?: any;
  authData?: any;
  code?: string | null;
  email?: string | null;
}

const Authentication: React.FC<IProps> = props => {
  const { push } = useHistory();

  useEffect(() => {
    redirectToLogin(push);
  }, [push]);

  const { search } = useLocation();
  const [form] = Form.useForm();
  if (props.authState === 'signedIn') {
    return <Redirect to={'/'} />;
  }
  let qs = search;
  if (qs.charAt(0) === '?') {
    qs = qs.slice(1);
  }
  const { email, code } = qs.split('&').reduce((a, b) => {
    const [key, val] = b.split('=');
    a[key] = val;
    return a;
  }, {}) as { email?: string; code?: string };

  const state = email ? 'confirmSignUp' : props.authState;

  switch (state) {
    case 'signIn':
      return <SignIn {...props} form={form} />;
    case 'signUp':
      return <SignUp {...props} form={form} />;
    case 'forgotPassword':
      return <ForgotPassword {...props} code={code} form={form} />;
    case 'confirmSignUp':
      return <ConfirmSignUp {...props} code={code} email={email} form={form} />;
    case 'requireNewPassword':
      return <NewPassword {...props} form={form} />;
    default:
      return <div />;
  }
};

export default Authentication;
